import NRExportToCsvContent from './NRExportToCsvContent';
import Modal from '@mui/material/Modal';

function NRExportToCsvDialog({ isOpen = true, setIsOpen, selectAllFetchConfig, totalCount, customRouteName }) {
  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Modal open={isOpen} onClose={handleClose} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
      <NRExportToCsvContent
        selectAllFetchConfig={selectAllFetchConfig}
        handleClose={handleClose}
        totalCount={totalCount}
        customRouteName={customRouteName}
      />
    </Modal>
  );
}

export default NRExportToCsvDialog;
